import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tuisong",
  "use": "icon-tuisong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tuisong\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 192L441.6 896l-138.752-251.264 78.272-41.728 71.296 129.088 287.36-390.272L220.8 567.36v183.936l-89.088 62.72V510.528l79.36-34.624L64 198.4 960 192z m-301.824 89.6l-447.872 3.264 82.496 155.52 365.376-158.72z\" p-id=\"10149\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol